export default __webpack_public_path__ + "static/media/icon_joy_type_a.cec1ea1f.png";